import { obtenerIniciales } from '../../utils/ObtenerIniciales'
import { AppMapas } from '../../utils/Constantes'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type Props = {
  nombre: string
  primerApellido?: string
  perfil: string
  estatus?: boolean
  ausente?: boolean
  margenFinal?: string
  tamaño?: string
  tamañoBullet?: string
  bullet?: boolean
}

/**
 * Avatar circular con iniciales del usuario, color segun perfil y bullet de estatus (activo/inactivo).
 * Se usa en el header, listados y dropdowns.
 */
export const UsuarioSymbol = ({
  nombre,
  primerApellido,
  perfil,
  estatus,
  margenFinal = 'me-3',
  tamaño = '40px',
  tamañoBullet = '12px',
  ausente,
  bullet = true,
}: Props) => {
  return (
    <>
      <div className={`symbol symbol-${tamaño} symbol-circle ${margenFinal}`}>
        <div
          className={`symbol-label fs-2 fw-semibold bg-${
            estatus ? AppMapas.MAPA_PERFIL_USUARIO.get(perfil) ?? 'dodger-blue' : 'gray-300'
          } ${
            estatus
              ? 'text-inverse-' + AppMapas.MAPA_PERFIL_USUARIO.get(perfil) ?? 'dodger-blue'
              : 'text-gray-600'
          } ${!estatus ? 'border border-gray-200' : ''}`}>
          {obtenerIniciales(nombre, primerApellido)}
          {bullet && (
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip>{`Usuario ${estatus ? 'activo' : 'no activo'}`}</Tooltip>}>
              <div
                className={`symbol-badge border border-body bg-${
                  estatus ? 'success' : 'gray-400'
                } start-100 top-100 border-1 ms-n2 mt-n2`}
                style={{ width: tamañoBullet, height: tamañoBullet }}></div>
            </OverlayTrigger>
          )}
        </div>
      </div>
    </>
  )
}
